import React, { useState, useEffect, useMemo } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import Axios from 'axios';
import shortid from 'shortid';
import {
    AcervoAPI,
    ConsultaAPI,
    PergamumKidsLayout,
    VinculosAPI,
} from '../../../../shared/http-requests';
import { ImageHelper } from '../../../../shared/helpers/ImageHelper';
import {
    ModalConstructor,
    SpinnerConstructor,
} from '../../../../shared/components';
import ModalVinculosPaginaDireita from '../../components/Home/ModalVinculosPaginaDireita';
import { APIHelper, ConsultaHelper } from '../../../../shared/helpers';
import CanIBorrowComponent from './CanIBorrowComponent';
import DadosAcervoReserva from '../../components/DadosAcervo/DadosAcervoReserva';

const CarouselDadosAcervoKids = React.lazy(() =>
    import('./CarouselDadosAcervoKids'),
);
const CardBreadCrumbs = React.lazy(() => import('./CardBreadCrumbs'));

/**
 * Componente DadosDoAcervo Versão Kids
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @returns {JSX.Element}
 * @constructor
 */
const DadosDoAcervo = props => {
    const { t } = useTranslation();

    const [dados, setDados] = useState(null);
    const { instituicaoRx, breadCrumbProps, dataAccessFromVitrine } = props;
    const [localBreadCrumbProps, setLocalBreadCrumbProps] = useState([
        'Dados do acervo',
    ]);
    const [dadosLocalizacao, setDadosLocalizacao] = useState(null);
    const [localizacao, setLocalizacao] = useState(false);
    const [capas, setCapas] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalLinksOpen, setModalLinksOpen] = useState(false);
    const [acervoAtual, setAcervoAtual] = useState(null);
    const { capaPadrao, pagePrefix } = props;
    const params = useParams();

    const { codAcervo, codBiblioteca } = params;
    const { selectedCategoryId } = props;

    const { search } = useLocation();
    const urlSearchParams = new URLSearchParams(search);
    const restOfUrl = urlSearchParams.get('codCategoria')
        ? `/${urlSearchParams.get('codCategoria')}`
        : '';

    const [view, setView] = useState('default');
    const [collectionReferenceData, setCollectionReferenceData] =
        useState(null);

    const [labels, setLabels] = useState({
        titulo_ano: t('TituloAno'),
        autor: t('Autor'),
        numero_chamada: t('AnoteEProcureComEsteNumero'),
        posso_emprestar: t('PossoEmprestar'),
        sim_existem_acervos: t('SimExistemAcervos'),
        localizado_em: t('AondeEncontro'),
        botao_ver_localizacao: t('VerLocalizacao'),
        nao_pode_emprestar: t('OpaNaoPodeEmprestar'),
        quando_volta: t('QuandoVolta'),
        estimativa_volta: t('VaiVoltarEm'),
        quer_reservar: t('QuerReservar'),
        botao_reservar: t('ReservarAgora'),
        posso_ver: t('PossoVer'),
        sim_pode_ver: t('Sim'),
        botao_ver_material: t('VerMaterialAgora'),
        texto_capa: t('CapaEImagensDoMaterial'),
    });

    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    const fetchCompleteCollectionData = async token => {
        try {
            const response = await ConsultaAPI.consulta(
                {
                    termo_pesquisa: codAcervo,
                    coluna_um: 'INDICE_30',
                    search_id: shortid.generate(),
                    search_tab: 'pesquisa_geral',
                },
                token,
            );
            const { data } = response;
            return data[0];
        } catch (error) {
            if (!Axios.isCancel(error)) {
                APIHelper.tratarErro(error);
            }
            console.log(error);
        }
        return null;
    };
    const fetchCollectionDataKids = async token => {
        try {
            const response = await PergamumKidsLayout.getDadosAcervo(
                codAcervo,
                codBiblioteca,
                token,
            );
            const { data } = response;
            if (data) {
                return data;
            }
        } catch (error) {
            console.log(error);
        }
        return null;
    };
    const fetchCollectionLabels = async (cancelToken = null) => {
        try {
            const response = await PergamumKidsLayout.getLabelsDadosAcervo(
                codBiblioteca,
                cancelToken,
            );
            const { data } = response;

            if (data && Object.keys(data).length > 0) return data;
        } catch (error) {
            console.log(error);
        }

        return null;
    };
    const fetchCollectionLinks = async token => {
        try {
            const response = await VinculosAPI.buscarLinksAcervos(
                `${codAcervo}`,
                token,
            );
            const { data } = response;
            if (data) {
                const { links } = data[0];
                if (links?.length) {
                    // acervoAtual.links = links;
                    return links;
                }
            }
        } catch (error) {
            APIHelper.tratarErro(error);
        }

        return null;
    };
    const fetchCollectionLocalization = async token => {
        try {
            const response = await PergamumKidsLayout.getLocalizacaoAcervo(
                codAcervo,
                codBiblioteca,
                token,
            );
            const { data } = response;
            if (data && Object.keys(data).length > 0) return data;
            // setDadosLocalizacao(data);
        } catch (error) {
            console.log(error);
        }
        return null;
    };
    const fetchCollectionImages = async token => {
        try {
            const response = await VinculosAPI.buscarImagensAcervo(
                codAcervo,
                0,
                token,
            );
            const { data } = response;
            if (data && data?.length > 0) {
                return [...data.map(item => item.conteudo)];
            }
            return null;
        } catch (error) {
            console.log(error);
        }
        return null;
    };
    const fetchCollectionReference = async token => {
        try {
            const response = await AcervoAPI.buscarReferenciaAcervo(
                codAcervo,
                token,
            );
            const { data } = response;
            if (data) {
                return data;
            }
        } catch (error) {
            if (!Axios.isCancel(error)) {
                return {
                    error: true,
                    message: error.response.data.message,
                };
            }
        }
        return null;
    };

    /**
     * principal
     */
    useEffect(() => {
        if (codAcervo === null) return;
        const cancelTokenSrc = Axios.CancelToken.source();
        const { token } = cancelTokenSrc;

        (async () => {
            setLoading(true);
            const completeCollectionData = await fetchCompleteCollectionData(
                token,
            );
            if (completeCollectionData) {
                const collectionData = await fetchCollectionDataKids(token);
                const collectionLinks = await fetchCollectionLinks(token);
                const collectionLabels = await fetchCollectionLabels(token);
                const collectionImages = await fetchCollectionImages(token);
                const collectionReferenceData = await fetchCollectionReference(
                    token,
                );

                if (collectionReferenceData) {
                    setCollectionReferenceData(collectionReferenceData);
                }

                if (collectionLinks) {
                    completeCollectionData.links = collectionLinks;
                }

                setAcervoAtual(completeCollectionData);

                if (collectionLabels) {
                    setLabels(collectionLabels);
                }

                if (collectionImages) {
                    setCapas(collectionImages);
                }

                if (collectionData) {
                    setDados(collectionData);
                    const { localizacao } = collectionData;
                    if (localizacao === 'S') {
                        /* busca dados da localização */
                        const collectionLocalization =
                            await fetchCollectionLocalization(token);
                        if (collectionLocalization) {
                            setDadosLocalizacao(collectionLocalization);
                        }
                    }
                }
            }
            setLoading(false);
        })();

        return () => {
            console.log('canceled');
            cancelTokenSrc.cancel();
        };
    }, [codAcervo]);

    /**
     * BreadCrumb
     */
    useEffect(() => {
        setLocalBreadCrumbProps({
            ...breadCrumbProps,
            breadCrumbLabel: [
                ...breadCrumbProps.breadCrumbLabel,
                'Dados do acervo',
            ],
            breadCrumbColor: breadCrumbProps?.breadCrumbColor ?? {backgroundColor: '#3399ff', cursor: 'pointer'},
            onClickBack: () => {
                history.push(
                    `/catalogos/${pagePrefix}/${codBiblioteca}${restOfUrl}`,
                );
            },
            onClickGoHome: () => {
                window.location.replace(`/catalogos/${pagePrefix}`);
            },
        });
    }, []);

    /**
     * BreadCrumb localização
     */
    useEffect(() => {
        if (['localization', 'reservation'].includes(view)) {
            const oldBreadCrumbProps = { ...localBreadCrumbProps };
            setLocalBreadCrumbProps({
                ...localBreadCrumbProps,
                breadCrumbLabel: [
                    ...localBreadCrumbProps.breadCrumbLabel,
                    view === 'localization' ? t('Localizacao') : t('Reserva'),
                ],
                onClickBack: () => {
                    setView('default');
                    setLocalBreadCrumbProps(oldBreadCrumbProps);
                },
                onClickGoHome: () => {
                    history.push(`/catalogos/${pagePrefix}`);
                },
            });
        }
    }, [view]);

    const renderLocalizacao = () => {
        if (dadosLocalizacao) {
            const src =
                instituicaoRx &&
                instituicaoRx?.url_localizacao_estante &&
                instituicaoRx?.url_localizacao_estante !== null
                    ? `${instituicaoRx.url_localizacao_estante}${dadosLocalizacao.arquivo_bmp}` // Se possui url de localização, utiliza ela
                    : `/imagens/localizacao/${dadosLocalizacao.arquivo_bmp}`;

            return (
                <Col lg={6}>
                    <h4 className="f500 r10 t10 s15 preto70">
                        <FontAwesomeIcon
                            icon="map-marker-alt"
                            fixedWidth
                            className="s15 r5"
                        />
                        {t('Localizacao')}
                    </h4>
                    <img alt={t('Localizacao')} src={src} />
                </Col>
            );
        }

        return <div />;
    };

    const getLocalizationBlock = useMemo(() => {
        // eslint-disable-next-line react/display-name
        return () => {
            if (!dadosLocalizacao) return null;
            const { url_localizacao_estante } = instituicaoRx ?? {
                url_localizacao_estante: null,
            };
            const { arquivo_bmp } = dadosLocalizacao;
            const src =
                url_localizacao_estante !== null
                    ? `${instituicaoRx.url_localizacao_estante}${dadosLocalizacao.arquivo_bmp}`
                    : `/imagens/localizacao/${arquivo_bmp}`;
            return (
                <Col lg={6}>
                    <h4 className="f500 r10 t10 s15 preto70">
                        <FontAwesomeIcon
                            icon="map-marker-alt"
                            fixedWidth
                            className="s15 r5"
                        />
                        {t('Localizacao')}
                    </h4>
                    <img alt={t('Localizacao')} src={src} />
                </Col>
            );
        };
    }, [dadosLocalizacao, instituicaoRx, t]);

    /**
     * Evento (reservar livro)
     * @param event
     */
    const handleClickBookReservation = event => {
        event.preventDefault();
        console.log('Book reservation clicked ...');
    };

    /**
     * Evento (Ver material)
     * @param event
     */
    const handleClickSeeMaterial = event => {
        event.preventDefault();
        if (acervoAtual && acervoAtual?.links?.length) {
            setModalLinksOpen(true);
        }
    };

    const getCanIBorrowBlok = () => {};

    const getHasAvailableCollectionsBlock = useMemo(() => {
        // eslint-disable-next-line react/display-name
        return () => {
            if (dados == null || labels == null) return null;
            const { sim_existem_acervos } = labels;
            const { total_exemplares_disponiveis } = dados;
            if (typeof sim_existem_acervos === 'string') {
                const parts = sim_existem_acervos.split('{qtd_acervos}');
                if (parts?.length) {
                    return (
                        <>
                            <span className="s18 f700">{parts[0]}</span>
                            <span className="f900 mx-2 verde s30">
                                {total_exemplares_disponiveis}
                            </span>
                            <span className="s18 f700">{parts[1]}</span>
                        </>
                    );
                }
            }
            return null;
        };
    }, [labels, dados]);

    if (loading) {
        return (
            <Container className="bkbranco rad10 p-1 sombra mt-2">
                <Row>
                    <Col
                        xs="12"
                        md={{ size: 4, offset: 4 }}
                        className="mt-5 p-md-5 p-0"
                    >
                        <div className="p-5 text-center animated fadeIn">
                            <SpinnerConstructor
                                visible
                                showLabel
                                height={80}
                                width={80}
                                className="apergamum"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }

    if (dados === null) {
        return (
            <Container className="p-0">
                <CardBreadCrumbs {...localBreadCrumbProps} />
                <Container className="bkbranco rad10 sombra mt-2 p-2">
                    <div className="rad10">Nenhum dado encontrado</div>
                </Container>
            </Container>
        );
    }

    const { pode_reservar, pode_emprestar, num_dias_voltar } = dados;

    const { texto_capa } = dados ?? {
        texto_capa: null,
    };

    return (
        <Container className="p-0">
            {/*  MODAL VINCULOS */}
            {acervoAtual ? (
                <ModalConstructor
                    closeable
                    size="lg"
                    title={t('LinksDocumentos')}
                    open={modalLinksOpen}
                    setOpen={setModalLinksOpen}
                >
                    <ModalVinculosPaginaDireita acervo={acervoAtual} />
                </ModalConstructor>
            ) : (
                ''
            )}
            {/*  MODAL VINCULOS */}

            <CardBreadCrumbs {...localBreadCrumbProps} />

            <Container className="bkbranco rad10 sombra mt-2">
                <div className="rad10">
                    <div className="">
                        <Row>
                            <Col xs="12" md="12">
                                {/* eslint-disable-next-line no-nested-ternary */}
                                {view === 'localization' ? (
                                    getLocalizationBlock()
                                ) : view === 'reservation' ? (
                                    <DadosAcervoReserva
                                        codAcervo={codAcervo}
                                        referencia={collectionReferenceData[0]}
                                    />
                                ) : (
                                    <>
                                        <Row className="my-3">
                                            <Col md="4" className="text-center">
                                                <span className="s16 f400 d-block mt-3 text-left pl-4">
                                                    {labels?.texto_capa}
                                                </span>
                                                <CarouselDadosAcervoKids
                                                    capas={
                                                        capas !== null
                                                            ? capas
                                                            : [capaPadrao?.capa]
                                                    }
                                                />
                                            </Col>
                                            <Col md="8" className="preto70">
                                                <span className="s16 f400 d-block">
                                                    {labels.titulo_ano}
                                                </span>
                                                <span className="s22 f700 d-block">
                                                    {dados.obra}
                                                </span>
                                                <div className="mb-3 b-teen" />

                                                <span className="s16 f400 d-block mt-3">
                                                    {labels.autor}
                                                </span>
                                                <span className="s18 f700 d-block">
                                                    {dados.autor}
                                                </span>

                                                {dados.chamada !== null ? (
                                                    <>
                                                        <span className="s16 f400 d-block mt-3">
                                                            {
                                                                labels.numero_chamada
                                                            }
                                                        </span>
                                                        <span className="b-solid-bottom b-teen2 b-w1 f700 px-3 py-1 rad20 s25 preto steen3 ">
                                                            {dados.chamada}
                                                        </span>
                                                    </>
                                                ) : (
                                                    ''
                                                )}

                                                {dados?.pode_emprestar
                                                    ?.trim()
                                                    ?.toLowerCase() !== 'o' ? (
                                                    <CanIBorrowComponent
                                                        setView={setView}
                                                        labels={labels}
                                                        data={dados}
                                                    />
                                                ) : (
                                                    ''
                                                )}

                                                {/* @TODO Verificar se deve ficar aqui esse bloco */}
                                                {(dados.doc_online &&
                                                    dados.doc_online?.trim() !==
                                                        '' &&
                                                    dados.doc_online?.trim() !==
                                                        'N' && (
                                                        <>
                                                            {/* Adicionar condição se pode ver */}
                                                            <span className="s16 f400 d-block mt-3">
                                                                {
                                                                    labels.posso_ver
                                                                }
                                                            </span>
                                                            <span className="s18 f700 d-inline-block mr-2">
                                                                {
                                                                    labels.sim_pode_ver
                                                                }
                                                            </span>
                                                            <button
                                                                onClick={
                                                                    handleClickSeeMaterial
                                                                }
                                                                type="submit"
                                                                className="b-solid b-teen3 b-w3 bkazul branco h-teen hover hpreto px-3 rad20 s14 sazul f500"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon="eye"
                                                                    className="mr-1 fa-fw"
                                                                />
                                                                <span>
                                                                    {
                                                                        labels.botao_ver_material
                                                                    }
                                                                </span>
                                                            </button>
                                                        </>
                                                    )) ||
                                                    (dados.doc_online &&
                                                        dados.doc_online?.trim() !==
                                                            '' &&
                                                        acervoAtual?.links
                                                            ?.length &&
                                                        dados.doc_online?.trim() !==
                                                            'N' && (
                                                            <>
                                                                {/* Adicionar condição se pode ver */}
                                                                <span className="s16 f400 d-block mt-3">
                                                                    {
                                                                        labels.posso_ver
                                                                    }
                                                                </span>
                                                                <span className="s18 f700 d-inline-block mr-2">
                                                                    {
                                                                        labels.sim_pode_ver
                                                                    }
                                                                </span>
                                                                <button
                                                                    onClick={() => {
                                                                        ConsultaHelper.acessarVinculo(
                                                                            codAcervo,
                                                                            acervoAtual
                                                                                .links[0]
                                                                                .seq_paragrafo,
                                                                            acervoAtual
                                                                                .links[0]
                                                                                .url_link,
                                                                        );
                                                                    }}
                                                                    type="submit"
                                                                    className="b-solid b-teen3 b-w3 bkazul branco h-teen hover hpreto px-3 rad20 s14 sazul f500"
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon="eye"
                                                                        className="mr-1 fa-fw"
                                                                    />
                                                                    <span>
                                                                        {
                                                                            labels.botao_ver_material
                                                                        }
                                                                    </span>
                                                                </button>
                                                            </>
                                                        ))}

                                                {dados?.cor_localizacao &&
                                                dados?.cor_localizacao !==
                                                    'VARIAS' &&
                                                dados?.cor_localizacao?.split(
                                                    '/',
                                                )[1] !== undefined ? (
                                                    <>
                                                        <span className="s16 f400 d-block mt-3">
                                                            {
                                                                labels.localizado_em
                                                            }
                                                        </span>
                                                        <div className="d-flex justify-content-start align-items-center my-3">
                                                            <div
                                                                className="rad50p text-center cor m-0 d-flex justify-content-center align-items-center"
                                                                style={{
                                                                    width: '48px',
                                                                    height: '48px',
                                                                    backgroundColor:
                                                                        dados.cor_localizacao.split(
                                                                            '/',
                                                                        )[0],
                                                                }}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon="street-view"
                                                                    className="s24 branco fa-fw"
                                                                />
                                                                <ReactTooltip place="right" />
                                                            </div>
                                                            <Col md="10">
                                                                <span className="s22 f700 d-block-inline  roxo  text-center">{`${t(
                                                                    'LocalizacaoEstante',
                                                                )} ${
                                                                    dados?.cor_localizacao?.split(
                                                                        '/',
                                                                    )[1]
                                                                }`}</span>
                                                            </Col>
                                                        </div>
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                                {/* Modificação solicitada pelo Maciel em 16-07-2024 */}
                                                {dados?.pode_emprestar === 'S' && dados?.total_exemplares_disponiveis > 0 && dadosLocalizacao !== null ? (
                                                    <>
                                                        <span className="s16 f400 d-block mt-3">
                                                            {
                                                                labels.localizado_em
                                                            }
                                                        </span>
                                                        <div>
                                                            <Button
                                                                onClick={() => {
                                                                    setView(
                                                                        'localization',
                                                                    );
                                                                }}
                                                                className="mt-3 b-solid b-teen3 b-w3 bkazul branco h-teen hover hpreto px-3 rad20 s14 sazul f500 d-flex justify-content-center align-items-center"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon="map-marker-alt"
                                                                    className="mr-1 fa-fw"
                                                                />
                                                                <span>
                                                            {
                                                                labels.botao_ver_localizacao
                                                            }
                                                        </span>
                                                            </Button>
                                                        </div>
                                                    </>
                                                ) : ''}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12">
                                                <div className="text-right my-3 d-md-block ">
                                                    <Link
                                                        to={`/catalogos/${pagePrefix}/acervo/${codAcervo}/${codBiblioteca}${
                                                            urlSearchParams.get(
                                                                'codCategoria',
                                                            )
                                                                ? `?codCategoria=${urlSearchParams.get(
                                                                      'codCategoria',
                                                                  )}`
                                                                : ''
                                                        }`}
                                                        className="hover hroxo link p-1 rad5 roxo click"
                                                    >
                                                        Visualização completa
                                                    </Link>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        </Container>
    );
};

const mapStateToProps = state => ({
    instituicaoRx: state.instituicao.data,
    breadCrumbProps: state.pergamumKids.breadCrumbProps,
    selectedCategoryId: state.pergamumKids.selectedCategoryId,
    dataAccessFromVitrine: state.pergamumKids.dataAccessFromVitrine,
    capaPadrao: state.pergamumKids.capaPadrao,
    pagePrefix: state.pergamumKids.pagePrefix,
});

export default connect(mapStateToProps)(DadosDoAcervo);
